import YunJi from '@/common/js/YunJi'
import wxUtil from './wxUtil'
import wxShare from '../js/wxShare'
import wxConstData from '@/common/define/wxConstData'

const isDEV = window.location.hostname.split('.')[0] === 'v'

/**
 * 跳转页面处理
 * @param {*} path 
 * @param {*} params 
 * @returns 
 */
export function jumpPage(path, params = {}, ctxContet) {
  if(!path) return
  const { query, 
    hideNavBar = true,
    minProgramWebViewPath = '/pages/index/index', 
    navBgColor = '#ffffff',
    navFontColor = '#000000',
    replace = false 
  } = params
  const basePath = params.basePath || ''
  // app 和 小程序webview用
  // 隐藏 app 标题栏
  query.hideNavBar = hideNavBar
  const originPath = isDEV ? `${window.location.protocol}//${window.globalConfig.linkPath}` : window.location.origin
  // const originPath = window.location.origin
  
  const { appCont } = query 

  const targetUrl = `${originPath}${basePath}${path}${YunJi.entityToUrl(query)}`

  if (YunJi.isApp()) {
    // app规则外链
    window.location.href = 'yunji://gotoExternalLink?url=' + encodeURIComponent(targetUrl);
  } else if(appCont == 7){
    query.navBgColor = encodeURIComponent(navBgColor)
    query.navFontColor = encodeURIComponent(navFontColor)
    if (replace) {
      wxUtil.redirectTo({ url: `${minProgramWebViewPath}${YunJi.entityToUrl(query)}&linkUrl=${encodeURIComponent(`${originPath}${basePath}${path}`)}` })
    } else {
      wxUtil.forwardTo({ url: `${minProgramWebViewPath}${YunJi.entityToUrl(query)}&linkUrl=${encodeURIComponent(`${originPath}${basePath}${path}`)}` })
    }
  } else {
    if(replace) {
      window.location.href = targetUrl
      // ctxContet.$router.replace({
      //   path,
      //   query: {...query}
      // })
    } else {
      ctxContet.$router.push({
        path,
        query: {...query}
      })
    }
  }
}

/**
 * 跳转页面处理
 * @param {*} path 
 * @param {*} params 
 * @returns 
 */
export function jumpPageSimple(path, params = {}, ctxContet) {
  if(!path) return
  const {minProgramWebViewPath, appCont, fix = 1} = params
  if (YunJi.isApp()) {
    // app规则外链
    window.location.href = 'yunji://gotoExternalLink?url=' + encodeURIComponent(path);
  } else if(appCont == 7){
    const path1 = path.split('?')[0]
    const path2 = path.split('?')[1]
    // 直接跳转
    if(fix == 2) {
      wxUtil.forwardTo({url: path})
    } else if(minProgramWebViewPath.includes('commom-activity')) {
      // 特殊处理
      wxUtil.forwardTo({ url: `${minProgramWebViewPath}?${path2}&linkUrl=${encodeURIComponent(path1)}` })
    } else {
      // 默认
      wxUtil.forwardTo({ url: `/pages/common-webview/common-webview?from=COMMONPAGE&comonPageType=3&canShare=0&pageUrl=${encodeURIComponent(path)}` })
    }
  } else {
    ctxContet.$router.push({
      path
    })
  }
}

/**
 * 跳转专题
 * @param {*} id 
 * @param {*} commonParam 
 * @param {*} resParam 
 */
export function goSubject(id, commonParam = {}, resParam = {}) {
  const urlParam = { 
    ...{
      subjectId: id
    }, 
    ...commonParam,
    ...resParam 
  }
  
  if (urlParam.appCont == 7) {
    wxUtil.forwardTo({ url: `/pages/subject/subject${YunJi.entityToUrl(urlParam)}` })
  } else if (YunJi.isApp()) {
    window.location.href = `yunji://common/openSubjectWithParam?subjectParam=${encodeURIComponent(JSON.stringify(urlParam))}`
  } else {
    window.location.href = `//${globalConfig.yunjibuyerPath}/yj/subject${YunJi.entityToUrl(urlParam)}`
  }
}

/**
 * 跳转超级品牌团
 * @param {*} appCont 
 * @param {*} shopId 
 */
 export function goSuperBrand(appCont, shopId) {
  const targetUrl = `${location.protocol}//${globalConfig.yunjibuyerPath}/yjbuyer/superBrand?hideNavBar=true&shopId=${shopId}&appCont=${appCont}`
  if (appCont == 7) {
    wxUtil.forwardTo({ url: `/pages/common-webview/common-webview?from=COMMONPAGE&comonPageType=3&canShare=0&pageUrl=${encodeURIComponent(targetUrl)}` })
  } else if (YunJi.isApp()) {
    window.location.href = 'yunji://gotoExternalLink?url=' + encodeURIComponent(targetUrl);
  } else {
    window.location.href = targetUrl
  }
}

/**
 * 跳转优惠券
 * @param {*} appCont 
 * @param {*} shopId 
 */
export function goCouponList(appCont, shopId) {
  if (appCont == 7) {
    wxUtil.forwardTo({ url: `/pages/coupon-list/coupon-list?shopId=${shopId}` })
  } else if (YunJi.isApp()) {
    window.location.href = 'yunji://subjectGotoCoupon'
  } else {
    window.location.href = `//${globalConfig.yunjibuyerPath}/yjbuyer/coupon-canuse?shopId=${shopId}&appCont=${appCont}`
  }
}

/**
 * 跳转云币
 * @param {*} appCont 
 * @param {*} shopId 
 */
export function goCoinList(appCont, shopId) {
  if (appCont == 7) {
    wxUtil.forwardTo({ url: `/pages/cloudcoin-list/cloudcoin-list?shopId=${shopId}` })
  } else if (YunJi.isApp()) {
    window.location.href = 'yunji://subjectGotoYunbi'
  } else {
    window.location.href = `//${globalConfig.yunjibuyerPath}/yjbuyer/coupon-list?shopId=${shopId}&appCont=${appCont}`
  }
}

/**
 * 跳转商详
 * @param {*} appCont 
 * @param {*} shopId 
 */
export function goItemInfo(itemId, appCont, shopId) {
  if (appCont == 7) {
    wxUtil.forwardTo({ url: `/pages/detail/detail?itemId=${itemId}&origin=1&shopId=${shopId}` })
  } else if (YunJi.isApp()) {
    window.location.href = `yunji://doubleTwelve/itemDetail?itemId=${itemId}`
  } else {
    window.location.href = `//${globalConfig.yunjibuyerPath}/yjbuyer/detail?appCont=0&shopId=${shopId}&itemId=${itemId}`
  }
}
/**
 * 跳转内容商详
 * @param {*} appCont 
 * @param {*} shopId 
 */
 export function goSuperDetail(itemId, appCont, shopId,seedLabel=0) {
  if (appCont == 7) {
      // 内容商详
      let baseUrl = `/mall/pages/detail-content/detail-content?itemId=${itemId}&shopId=${shopId}&from=channel&noteId=${seedLabel}`
    wxUtil.forwardTo({ url: baseUrl })
  } else if (YunJi.isApp()) {
    let url = `yunji://common/itemDetail?itemId=${itemId}&pageSource=0&pageType=1&noteId=${seedLabel}`
    window.location.href = url
  } else {
    window.location.href = `//${globalConfig.yunjibuyerPath}/yjbuyer/detail?appCont=0&shopId=${shopId}&itemId=${itemId}&noteId=${seedLabel}`
  }
}
/**
 * 跳转首页
 * @param {*} appCont 
 * @param {*} shopId 
 */
export function goHome(appCont = 0, shopId = 968) {
  if (appCont == 7) {
    wxUtil.forwardTo({ url: `/pages/index/index?shopId=${shopId}` })
  } else if (YunJi.isApp()) {
    window.location.href = 'yunji://common/goHome'
  } else {
    window.location.href = `//${globalConfig.yunjibuyerPath}/yjbuyer/more?shopId=${shopId}&appCont=0`
  }
}
/**
 * 跳转上一个页面
 * @param {*} appCont 
 * @param {*} ctxContet 
 */
export function jumpActGoBack(appCont = 0,ctxContet){
  if (YunJi.isApp()) {
    window.location.href = 'yunji://common/goBack'
  } else if (appCont == 7) {
    wx.miniProgram.navigateBack({
      delta: 1
    })
  } else {
    ctxContet.$router.go(-1)
  }
}
/**
 * 跳转直播间
 * @param {*} liveId 
 * @param {*} appCont 
 * @param {*} shopId 
 */
export function goLive(liveId, appCont, shopId){
  if (appCont == 7) {
    wxUtil.forwardTo({ url: `/live/pages/live-list/live-list?liveId=${liveId}shopId=${shopId}&appCont=7&inviterType=0&consumerId=0` })
  } else if (YunJi.isApp()) {
    window.location.href = `yunji://common/golive?liveId=${liveId}`
  } else {
    window.location.href = `//${globalConfig.yunjibuyerPath}/yjcommodity/live-broadcasts?liveId=${liveId}&shopId=${shopId}&appCont=0&inviterType=0&consumerId=0`
  }
}

/**
 * @param {*} info 视频号直播间信息
 * @param {*} appCont 
 * @param {*} shopId 
 */
export function goVideoChannel(info, appCont, shopId, params = {}) {
  const {
    userName, 
    miniProgramType, 
    weixinAppId, 
    finderId,
    liveId,
    type = 1,
  } = info || {}
  let url = `/user/pages/channel-middle/channel-middle?type=${type}&shopId=${shopId}&appCont=${appCont}&videoId=${finderId}&feedId=${liveId}`
  if(Object.keys(params).length > 0) {
    url = `${url}${YunJi.entityToUrl(params, true)}`
  }
  if (appCont == 1 || appCont == 2) {
    window.location.href = `yunji://common/launchMiniProgram?appId=${weixinAppId}&userName=${userName}&miniprogramType=${miniProgramType}&path=${encodeURIComponent(url)}`
  } else if (appCont == 7) {
    wxUtil.forwardTo({ url })
  } else {
  }
}

/**
 * 
 * @param {*} roomId 直播间id 不传则是跳 直播列表
 */
export function goLiveNew(roomId, params = {}) {
  let url = !roomId ? '/mall/pages/live-room-list/live-room-list?sourceId=channel' : `/mall/pages/live-middle-pages/index?roomId=${roomId}`
  if(Object.keys(params).length > 0) {
    url = `${url}${YunJi.entityToUrl(params, true)}`
  }
  jumpToMiniprogram(url, wxConstData.applicationAppId, wxConstData.yunjiWXAppOriginId, YunJi.isProd()?0:2)
}
/**
 * 跳转榜单
 * @param {*} appCont 
 * @param {*} shopId 
 */
export function goBrandGroup(brandId, appCont, shopId) {
  if (appCont == 7) {
    wxUtil.forwardTo({ url: `/pages/index/index?shopId=${shopId}` })
  } else if (YunJi.isApp()) {
    window.location.href = `yunji://common/goBrandGroup?brandId=${brandId}`
  } else {
    window.location.href = `//${globalConfig.yunjibuyerPath}/yjbuyer/brand-list?brandId=${brandId}&shopId=${shopId}&appCont=${appCont}`
  }
}

/**
   * APP跳转小程序
   * https://api.yunjiglobal.com/web/?#/1?page_id=217
   * @param appId APPID云集app的id Release:wxfe4380f4c0fa7571  Debug:wx9fe36a8d86547189
   * @param userName 小程序名可填小程序原始id
   * @param miniType 分享小程序的版本,默认正式 0 正式 1开发 2体验
   * @param path 拉起小程序页面的可带参路径，不填默认拉起小程序首页，对于小游戏，可以只传入 query 部分，来实现传参效果，如：传入 “?foo=bar”。Path含多个参数需要进行编码操作
 */
 export function jumpToMiniprogram(path, appId = wxConstData.applicationAppId, userName = wxConstData.yunjiWXAppOriginId, miniType = 2) {
  miniType = YunJi.isProd()?0:2
  let url = `yunji://common/launchMiniProgram?appId=${appId}&userName=${userName}&miniprogramType=${miniType}`
  if (path) {
    url += `&path=${encodeURIComponent(path)}`
  }
  window.location.href = url
}

/**
 * APP分享小程序 
 * @param {*} shareAppletImg 小程序封面图片
 * @param {*} shareAppletText 小程序分享文案
 * @param {*} shareAppletUrl 小程序路径
 * @param {*} wechatAppId Release:wxfe4380f4c0fa7571  Debug:wx9fe36a8d86547189
 * @param {*} userName  小程序原始id
 * @param {*} miniType 分享小程序的版本,默认正式 0 正式 1开发 2体验
 */
export function shareToMiniprogram(shareAppletImg, shareAppletText, shareAppletUrl, wechatAppId, userName, miniType = 1) {
  const img = `hdImageURL=${encodeURIComponent(shareAppletImg)}&thumbImageURL=${encodeURIComponent(shareAppletImg)}`
  const path = `path=${encodeURIComponent(shareAppletUrl)}&webpageUrl=${encodeURIComponent(shareAppletUrl)}`
  const params = `${img}&appid=${wechatAppId}&appId=${wechatAppId}&miniProgramType=${miniType}&title=${shareAppletText}&${path}`
  window.location.href = `yunji://common/shareToChannel?shareChannel=1&userName=${userName}&${params}`
}

/**
 * APP分享H5
 * @param {*} shareUrl  分享页面路径
 * @param {*} shareTitle  分享标题
 * @param {*} shareContent  副标题
 * @param {*} shareImage  分享图标
 */
 export function shareToH5Wechat(shareUrl, shareTitle, shareContent, shareImage, shopId) {
  const Url = `${shareUrl}&shopId=${shopId}&appCont=0`
  window.location.href = `yunji://doubleTwelve/share?link=${encodeURIComponent(Url)}&title=${shareTitle}&content=${shareContent
  }&imgUrl=${encodeURIComponent(shareImage)}`
}

/**
 * APP分享朋友圈
 * @param {*} shareUrl  分享页面路径
 * @param {*} shareTitle  分享标题
 * @param {*} shareContent  副标题
 * @param {*} shareImage  分享图标
 */
export function shareToWxFriend(link, imgUrl, title, content, callbackName) {
  window.location.href = `yunji://common/shareFriendsMsg?link=${encodeURIComponent(link)}&imgUrl=${encodeURIComponent(imgUrl)}&title=${encodeURIComponent(title)}&content=${encodeURIComponent(content)}${callbackName?'&callback='+callbackName:''}`
}

/**
 * 设置分享信息 指在 h5 微信小程序
 * @param {*} appCont 
 * @param {*} shareInfo.title
 * @param {*} shareInfo.content
 * @param {*} shareInfo.link
 * @param {*} shareInfo.imgUrl
 * 
 * title
 * path
 * imageUrl
 */
export function setWxConfig(appCont, shareInfo = {}, type = 'show') {
  if(appCont == 7) {
    wx.miniProgram.postMessage({ data: {
      title: shareInfo.title,
      path: shareInfo.link,
      imageUrl: shareInfo.imgUrl
    } })
  } else if(appCont == 0){
    wxShare({...shareInfo}, type)
  }
}


// 判断浏览器是否支持webp格式
export function checkWebp() {
  let isWebp = false
  try {
    const ele = document.createElement('object')
    ele.type = 'image/webp'
    ele.innerHTML = '!'
    document.body.appendChild(ele)
    // 如果浏览器支持webp,那么这个object是不可见的(offsetWidth为0),
    // 否则就会显示出来,有可视宽度.
    isWebp = !ele.offsetWidth
    document.body.removeChild(ele)
  } catch (err) {
    isWebp = false
  }
  return isWebp
}

// 校验是否支持webp
const isSupportWebp = (() => {
  return checkWebp()
})()


export function webpItemPic(result) {
  if (isSupportWebp) {
    // 支持webp的话把所有图片替换成webp格式
    result = JSON.parse(
      JSON.stringify(result).replace(
        /\.png/g,
        '.png?imageMogr2/format/webp'
      )
    )
  }
  return result
}

// 判断是否支持webp 支持就返回webp格式的图片
export const filterWebp = (imgUrl) => {
  // 一些有可能传入空字符串
  if (!imgUrl) {
    return imgUrl
  }
  // gif不能转换成webp
  if (imgUrl.includes('.gif')) {
    return imgUrl
  }

  try {
    // 没有document相当于在服务器执行，先假定支持webp  否则在初始化渲染模板的时候要加载一遍正常的图片再加载一遍webp的图片
    if (isSupportWebp) {
      const interfaceKeyWord = ['imageslim', 'imageView2', 'imageMogr2', 'imageInfo', 'exif', 'watermark', 'imageAve']
      const notProcessed = interfaceKeyWord.every(keyword => imgUrl.indexOf(keyword) === -1)
      if (notProcessed) {
        imgUrl += '?imageMogr2/format/webp'
      } else {
        imgUrl += '|imageMogr2/format/webp'
      }
    }
    return imgUrl
  } catch (e) {
    return imgUrl
  }
}

export function setStateBar() {
  if(YunJi.isApp()){
    if (!YunJi.getPhoneType()) {
      YunJi.appCommonRule('20190123', 'setStatusBarAlpha', '0')
    } else {
      YunJi.appCommonRule('20190123', 'setStatusBarFontColor', '1')
    }
  }
}



